export default __webpack_public_path__ + "static/postgresql-9fd3ef31554e1b30383713fd058d54c4.png";